import AddIcon from '@mui/icons-material/Add';
import { Box, Button, CircularProgress, ListItemIcon, Menu, MenuItem, Tooltip, Typography, ToggleButton, ToggleButtonGroup, Tabs, Tab } from "@mui/material";
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CategoriaCard } from '../../containers/CategoriaCard';
import { useCategorias } from '../../hooks/useCategorias';
import { useFetchCategorias } from "../../hooks/useFetchCategorias";
import { AccordionContainer, CadastrarCategoriaContainer, CardapioContainer, LoadingContainer, NenhumaCategoriaContainer } from "./styles";
import { useAutenticacaoContext } from '../../../core/contexts/AutenticacaoContext';
import { useEffect, useState } from 'react';
import { useMarketplaces } from '../../../marketplace/hooks/useMarketplaces';
import { useFetchMarketplaces } from '../../../marketplace/hooks/useFetchMarketplaces';
import { IMarketplace } from '../../../marketplace/interfaces/IMarketplace';
import { TipoMarketplace } from '../../../marketplace/enum/TipoMarketplace';
import { ICategoria } from '../../interfaces/ICategoria';
import { ArrowDropDown, Construction, Image, Extension, TableChart, ViewAgenda, CloudDownload } from '@mui/icons-material';
import { AtualizarImagensDrawer } from '../../components/AtualizarImagensDrawer';
import { CriarItemComplementoDrawer } from '../../components/CriarItemComplementoDrawer';
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragEndEvent } from '@dnd-kit/core';
import { SortableContext, sortableKeyboardCoordinates, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { TabelaProdutosCardapio } from './components/TabelaProdutosCardapio';
import { ConfirmarAcaoTextoModal } from '../../../core/components/ConfirmarAcaoTextoModal';
import { useSnackbar } from '../../../core/contexts/SnackbarContext';
import { IIntegracaoIFood } from '../../../marketplace/interfaces/IIntegracaoMarketplace';
import { CardapioIFood } from './components/CardapioIFood';
import { ImportarCardapioIFoodDrawer } from '../../components/ImportarCardapioIFoodDrawer';

type AbaCardapio = 'space-food' | 'ifood';

type ModoVisualizacao = 'lista' | 'tabela';

const LOCAL_STORAGE_KEY = 'cardapio-visualizacao-preferencia';

export const Cardapio = () => {
    const [openAtualizarImagens, setOpenAtualizarImagens] = useState(false);
    const [loadingReordenacao, setLoadingReordenacao] = useState(false);
    const [openCriarItemComplemento, setOpenCriarItemComplemento] = useState(false);
    const [openImportarIFood, setOpenImportarIFood] = useState(false);
    // Remonta a aba iFood após uma importação para recarregar os vínculos criados.
    const [versaoCardapioIFood, setVersaoCardapioIFood] = useState(0);
    const [modoVisualizacao, setModoVisualizacao] = useState<ModoVisualizacao>(() => {
        const salvo = localStorage.getItem(LOCAL_STORAGE_KEY);
        return (salvo === 'tabela' || salvo === 'lista') ? salvo : 'tabela';
    });
    const [categoriaExcluir, setCategoriaExcluir] = useState<ICategoria | undefined>(undefined);
    const [openExcluirCategoria, setOpenExcluirCategoria] = useState(false);
    const [loadingExcluirCategoria, setLoadingExcluirCategoria] = useState(false);
    const snackbar = useSnackbar();
    
    const handleAbrirAtualizarImagens = () => {
        setOpenAtualizarImagens(true);
        handleClose();
    }
    const handleFecharAtualizarImagens = () => {
        setOpenAtualizarImagens(false);
    }

    const handleAbrirCriarItemComplemento = () => {
        setOpenCriarItemComplemento(true);
        handleClose();
    }
    const handleFecharCriarItemComplemento = () => {
        setOpenCriarItemComplemento(false);
    }

    const handleAbrirImportarIFood = () => {
        setOpenImportarIFood(true);
        handleClose();
    }
    const handleFecharImportarIFood = () => {
        setOpenImportarIFood(false);
    }

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );

    const navigate = useNavigate();
    const { excluir: excluirCategoria, salvar: salvarCategoria, duplicar: duplicarCategoria } = useCategorias();

    const { categorias, isLoading, handleRefresh } = useFetchCategorias();

    const { verificarAcessoFuncionalidade, perfil } = useAutenticacaoContext();
    useEffect(() => {
        if (perfil && !verificarAcessoFuncionalidade("Listagem de categorias")) {
            navigate("/nao-autorizado")
        }
    }, [perfil])

    const { marketplaces, loading: loadingMarketplaces } = useFetchMarketplaces();
    const [searchParams, setSearchParams] = useSearchParams();

    const ifoodMarketplace = marketplaces?.find(marketplace =>
        marketplace.tipo === TipoMarketplace.IFOOD &&
        !!(marketplace.configuracao?.integracao as IIntegracaoIFood | undefined)?.merchantId
    );
    const [abaAtiva, setAbaAtiva] = useState<AbaCardapio>('space-food');
    const podeImportarIFood = !!ifoodMarketplace && verificarAcessoFuncionalidade("Gestão de categorias");

    async function handleExcluirCategoria(categoria: ICategoria) {
        const resposta = await excluirCategoria(categoria.uuid as string);
        return resposta;
    }

    const reordenarCategorias = async (categoriaA: ICategoria, categoriaB: ICategoria) => {
        if (!categoriaA.uuid || !categoriaB.uuid || categoriaA.posicao === undefined || categoriaB.posicao === undefined) {
            return;
        }

        const posicaoA = categoriaA.posicao;
        const posicaoB = categoriaB.posicao;

        setLoadingReordenacao(true);

        try {
            // Passo 1: Mover categoriaA para posição temporária 999999
            await salvarCategoria({
                ...categoriaA,
                produtos: [], // Remove produtos para evitar envio desnecessário
                posicao: 999999
            });

            // Passo 2: Mover categoriaB para a posição de A
            await salvarCategoria({
                ...categoriaB,
                produtos: [], // Remove produtos para evitar envio desnecessário
                posicao: posicaoA
            });

            // Passo 3: Mover categoriaA da posição temporária para a posição de B
            await salvarCategoria({
                ...categoriaA,
                produtos: [], // Remove produtos para evitar envio desnecessário
                posicao: posicaoB
            });

            // Atualizar a lista
            await handleRefresh();
        } catch (error) {
            console.error('Erro ao reordenar categorias:', error);
            await handleRefresh();
        } finally {
            setLoadingReordenacao(false);
        }
    }

    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;

        if (!over || active.id === over.id || !categorias || loadingReordenacao) {
            return;
        }

        const oldIndex = categorias.findIndex(cat => cat.uuid === active.id);
        const newIndex = categorias.findIndex(cat => cat.uuid === over.id);

        if (oldIndex === -1 || newIndex === -1) {
            return;
        }

        const categoriaMovida = categorias[oldIndex];
        const categoriaDestino = categorias[newIndex];

        reordenarCategorias(categoriaMovida, categoriaDestino);
    }

    const handleModoVisualizacaoChange = (event: React.MouseEvent<HTMLElement>, newModo: ModoVisualizacao | null) => {
        if (newModo !== null) {
            setModoVisualizacao(newModo);
            localStorage.setItem(LOCAL_STORAGE_KEY, newModo);
        }
    };

    const handleAcaoSelecionada = async (categoriaUuid: string, acao: 'cadastrar-produto' | 'editar-categoria' | 'excluir-categoria' | 'duplicar-categoria') => {
        const categoria = categorias?.find(cat => cat.uuid === categoriaUuid);
        if (!categoria) return;

        switch (acao) {
            case 'cadastrar-produto':
                navigate(`/cardapio/categorias/${categoriaUuid}/produtos`);
                break;
            case 'editar-categoria':
                navigate(`/cardapio/categorias/${categoriaUuid}`);
                break;
            case 'excluir-categoria':
                setCategoriaExcluir(categoria);
                setOpenExcluirCategoria(true);
                break;
            case 'duplicar-categoria':
                await duplicarCategoria(categoriaUuid);
                handleRefresh();
                break;
        }
    };

    const handleFecharExcluirCategoria = () => {
        setOpenExcluirCategoria(false);
        setCategoriaExcluir(undefined);
        setTimeout(() => handleRefresh(), 300);
    };

    const handleConfirmarExcluirCategoria = async () => {
        if (!categoriaExcluir) return;
        setLoadingExcluirCategoria(true);
        const resultado = await handleExcluirCategoria(categoriaExcluir);
        setLoadingExcluirCategoria(false);

        if (!resultado) {
            return snackbar("Ocorreu um erro ao excluir a categoria", { severity: "error" });
        }

        handleFecharExcluirCategoria();
        snackbar("Categoria excluída com sucesso", { severity: "success" });
    };

    return (
        <CardapioContainer>
            {ifoodMarketplace && (
                <Tabs
                    value={abaAtiva}
                    onChange={(_event, novaAba: AbaCardapio) => setAbaAtiva(novaAba)}
                    sx={{ width: '100%', marginTop: '1.5rem', marginBottom: '0.5rem', borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Space Food" value="space-food" />
                    <Tab label="iFood" value="ifood" />
                </Tabs>
            )}
            {abaAtiva === 'ifood' && ifoodMarketplace ? (
                <CardapioIFood
                    key={versaoCardapioIFood}
                    marketplaceUuid={ifoodMarketplace.uuid as string}
                    onImportar={podeImportarIFood ? handleAbrirImportarIFood : undefined}
                />
            ) : (
            <>
            <CadastrarCategoriaContainer>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
                    <ToggleButtonGroup
                        value={modoVisualizacao}
                        exclusive
                        onChange={handleModoVisualizacaoChange}
                        aria-label="modo de visualização"
                        size="small"
                    >
                        <ToggleButton value="tabela" aria-label="visualização em tabela">
                            <TableChart sx={{ mr: 1 }} />
                            Tabela
                        </ToggleButton>
                        <ToggleButton value="lista" aria-label="visualização em lista">
                            <ViewAgenda sx={{ mr: 1 }} />
                            Lista
                        </ToggleButton>
                    </ToggleButtonGroup>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                        <Button
                            endIcon={<Construction />}
                            variant={"outlined"}
                            onClick={handleClick}
                        >
                            Ferramentas
                        </Button>
                        <Menu
                            id={`ferramentas-menu`}
                            MenuListProps={{
                                'aria-labelledby': `ferramentas-menu`,
                            }}
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                        >
                            <Tooltip title='Atualize a imagem de produtos e itens em massa'>
                                <MenuItem onClick={handleAbrirAtualizarImagens}>
                                    <ListItemIcon color="inherit">
                                        <Image fontSize={"small"} />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap>
                                        Atualizar imagens
                                    </Typography>
                                </MenuItem>
                            </Tooltip>
                            <Tooltip title='Crie um novo item e adicione em complementos selecionados'>
                                <MenuItem onClick={handleAbrirCriarItemComplemento}>
                                    <ListItemIcon color="inherit">
                                        <Extension fontSize={"small"} />
                                    </ListItemIcon>
                                    <Typography variant="inherit" noWrap>
                                        Criar item de complemento
                                    </Typography>
                                </MenuItem>
                            </Tooltip>
                            {podeImportarIFood && (
                                <Tooltip title='Leia o cardápio do iFood e crie os produtos na Space Food, já vinculados'>
                                    <MenuItem onClick={handleAbrirImportarIFood}>
                                        <ListItemIcon color="inherit">
                                            <CloudDownload fontSize={"small"} />
                                        </ListItemIcon>
                                        <Typography variant="inherit" noWrap>
                                            Importar cardápio do iFood
                                        </Typography>
                                    </MenuItem>
                                </Tooltip>
                            )}
                        </Menu>
                        <Tooltip title='Cadastre uma nova categoria'>
                            <Button
                                startIcon={<AddIcon />}
                                onClick={() => navigate('/cardapio/categorias')}
                                variant="contained"
                                color="primary"
                            >
                                Categoria
                            </Button>
                        </Tooltip>
                    </Box>
                </Box>
            </CadastrarCategoriaContainer>
            {loadingReordenacao || isLoading ? (
                <LoadingContainer>
                    <CircularProgress />
                </LoadingContainer>
            ) : (
                categorias && marketplaces && !loadingMarketplaces && categorias.length > 0 ? (
                    modoVisualizacao === 'tabela' ? (
                        <TabelaProdutosCardapio
                            categorias={categorias}
                            marketplaces={marketplaces}
                            onAcaoSelecionada={handleAcaoSelecionada}
                            handleRefresh={handleRefresh}
                        />
                    ) : (
                        <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragEnd={handleDragEnd}
                        >
                            <SortableContext
                                items={categorias.map(cat => cat.uuid as string)}
                                strategy={verticalListSortingStrategy}
                            >
                                {categorias.map(categoria => {
                                    const marketplacesCategoria: IMarketplace[] = [];

                                    categoria.marketplaces?.map(marketplaceCategoria => {
                                        const marketplaceEncontrado = marketplaces?.find(marketplace => {
                                            if ((marketplace.tipo == marketplaceCategoria.tipo) && marketplace.tipo == TipoMarketplace.PDV) {
                                                return marketplace;
                                            }

                                            if (marketplace.uuid == marketplaceCategoria.uuid
                                                
                                            ) {
                                                return marketplace;
                                            }
                                        })

                                        if (marketplaceEncontrado) marketplacesCategoria.push(marketplaceEncontrado);
                                    })

                                    return (
                                        <AccordionContainer key={categoria.uuid}>
                                            <CategoriaCard
                                                handleRefresh={handleRefresh}
                                                excluirCategoria={handleExcluirCategoria}
                                                categoria={categoria}
                                                categorias={categorias}
                                                marketplaces={marketplacesCategoria}
                                            />
                                        </AccordionContainer>
                                    )
                                })}
                            </SortableContext>
                        </DndContext>
                    )
                ) : (
                    <NenhumaCategoriaContainer>
                        <img src={`${process.env.PUBLIC_URL}/images/astronaut.png`} />
                        <Typography variant='h5' sx={{ marginTop: "2rem" }}>
                            Nenhuma categoria criada
                        </Typography>
                        <Typography variant='subtitle1' sx={{ marginTop: "0.5rem" }}>
                            Monte seu cardápio de forma simples e intuitiva
                        </Typography>
                        {podeImportarIFood && (
                            <Button
                                sx={{ marginTop: "1.5rem" }}
                                variant="outlined"
                                startIcon={<CloudDownload />}
                                onClick={handleAbrirImportarIFood}
                            >
                                Importar cardápio do iFood
                            </Button>
                        )}
                    </NenhumaCategoriaContainer>
                )
            )}
            </>
            )}
            {categoriaExcluir && (
                <ConfirmarAcaoTextoModal
                    open={openExcluirCategoria}
                    titulo={`Excluir categoria: ${categoriaExcluir.descricao}`}
                    mensagem={<>Para confirmar a exclusão, digite <b>{categoriaExcluir.descricao}</b> no campo.</>}
                    parametro={categoriaExcluir.descricao}
                    cancelar={handleFecharExcluirCategoria}
                    confirmar={handleConfirmarExcluirCategoria}
                    loading={loadingExcluirCategoria}
                />
            )}
            <AtualizarImagensDrawer 
                categorias={categorias}
                handleCancelar={handleFecharAtualizarImagens}
                handleRefresh={handleRefresh}
                open={openAtualizarImagens}
            />
            {ifoodMarketplace && (
                <ImportarCardapioIFoodDrawer
                    open={openImportarIFood}
                    marketplaceUuid={ifoodMarketplace.uuid as string}
                    marketplaces={marketplaces ?? []}
                    handleCancelar={handleFecharImportarIFood}
                    handleRefresh={() => {
                        handleRefresh();
                        setVersaoCardapioIFood(versao => versao + 1);
                    }}
                />
            )}
            {categorias && (
                <CriarItemComplementoDrawer
                    categorias={categorias}
                    handleCancelar={handleFecharCriarItemComplemento}
                    handleRefresh={handleRefresh}
                    open={openCriarItemComplemento}
                />
            )}
        </CardapioContainer>
    )
}